export class ReleaseModel {
    _id: string;
    name: string;
    isUxSet: boolean;
    valueUx: number;
    isUySet: boolean;
    valueUy: number;
    isUzSet: boolean;
    valueUz: number;
    isPhixSet: boolean;
    valuePhix: number;
    isPhiySet: boolean;
    valuePhiy: number;
    isPhizSet: boolean;
    valuePhiz: number;


    constructor(id = null,
        name = '',
        description = '',
        isUxSet = false,
        valueUx = null,
        isUySet = false,
        valueUy = null,
        isUzSet = false,
        valueUz = null,
        isPhixSet = false,
        valuePhix = null,
        isPhiySet = false,
        valuePhiy = null,
        isPhizSet = false,
        valuePhiz = null,
    ) {
        this._id = id;
        this.name = name;
        this.isUxSet = isUxSet;
        this.valueUx = valueUx;
        this.isUySet = isUySet;
        this.valueUy = valueUy;
        this.isUzSet = isUzSet;
        this.valueUz = valueUz;
        this.isPhixSet = isPhixSet;
        this.valuePhix = valuePhix;
        this.isPhiySet = isPhiySet;
        this.valuePhiy = valuePhiy;
        this.isPhizSet = isPhizSet;
        this.valuePhiz = valuePhiz;
    }
}
